export interface BannerItem {
  id: string;
  animeId: string;
  title: string;
  subtitle: string;
  tag: string;
  image: string;
}

export const banners: BannerItem[] = [
  {
    id: "banner-01",
    animeId: "sword-and-sky",
    title: "剑与苍穹",
    subtitle: "魔剑低语，少年踏上揭开苍穹之谜的旅途",
    tag: "本季热播",
    image:
      "https://readdy.ai/api/search-image?query=epic%20anime%20key%20visual%20wide%20banner%20of%20a%20young%20swordsman%20on%20a%20cliff%20facing%20a%20vast%20dramatic%20sky%20with%20glowing%20sword%20light%2C%20cinematic%20composition%2C%20deep%20contrast%20left%20side%20for%20text%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20no%20text%2C%20high%20detail&width=1600&height=700&seq=hero-banner-01&orientation=landscape",
  },
  {
    id: "banner-02",
    animeId: "dragon-heir",
    title: "龙之继承者",
    subtitle: "血脉苏醒，与巨龙一同书写史诗",
    tag: "高分推荐",
    image:
      "https://readdy.ai/api/search-image?query=epic%20anime%20key%20visual%20wide%20banner%20of%20a%20dragon%20rider%20soaring%20above%20misty%20golden%20mountain%20peaks%2C%20cinematic%20scale%2C%20deep%20contrast%20left%20side%20for%20text%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20no%20text%2C%20high%20detail&width=1600&height=700&seq=hero-banner-02&orientation=landscape",
  },
  {
    id: "banner-03",
    animeId: "urban-mystery",
    title: "都市异闻录",
    subtitle: "霓虹之下，每桩悬案都藏着超常真相",
    tag: "悬疑新番",
    image:
      "https://readdy.ai/api/search-image?query=epic%20anime%20key%20visual%20wide%20banner%20of%20a%20detective%20in%20a%20rainy%20neon-lit%20city%20street%20at%20night%2C%20moody%20cinematic%20atmosphere%2C%20deep%20contrast%20left%20side%20for%20text%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20no%20text%2C%20high%20detail&width=1600&height=700&seq=hero-banner-03&orientation=landscape",
  },
  {
    id: "banner-04",
    animeId: "star-voyager",
    title: "星海旅人",
    subtitle: "在星海之间，寻找人类失落的航线",
    tag: "科幻佳作",
    image:
      "https://readdy.ai/api/search-image?query=epic%20anime%20key%20visual%20wide%20banner%20of%20a%20young%20astronaut%20before%20a%20colossal%20starship%20in%20a%20glowing%20nebula%2C%20cinematic%20depth%2C%20deep%20contrast%20left%20side%20for%20text%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20no%20text%2C%20high%20detail&width=1600&height=700&seq=hero-banner-04&orientation=landscape",
  },
  {
    id: "banner-05",
    animeId: "spirit-fox",
    title: "灵狐物语",
    subtitle: "为迷路的妖怪，寻找回家的路",
    tag: "治愈精选",
    image:
      "https://readdy.ai/api/search-image?query=epic%20anime%20key%20visual%20wide%20banner%20of%20a%20shrine%20maiden%20with%20a%20glowing%20white%20spirit%20fox%20in%20an%20enchanted%20bamboo%20forest%20at%20dusk%2C%20warm%20magical%20glow%2C%20deep%20contrast%20left%20side%20for%20text%2C%20cel-shaded%20digital%20painting%2C%20saturated%20colors%2C%20no%20text%2C%20high%20detail&width=1600&height=700&seq=hero-banner-05&orientation=landscape",
  },
];